// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/* tslint:disable */
/**
 * The Logger Registry token.
 */
export const ILoggerRegistry = new Token('@jupyterlab/logconsole:ILoggerRegistry');
//# sourceMappingURL=tokens.js.map